import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Page header with eyebrow + title + slot for actions. */
@Component({
  selector: 'app-page-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss',
})
export class PageHeaderComponent {
  eyebrow = input<string>('');
  title = input.required<string>();
  lead = input<string | null>(null);
}
